import { useTranslation } from 'react-i18next';

import type { PolicyStatus } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

const TONE: Record<PolicyStatus, string> = {
  published: 'bg-success/15 text-success border-transparent dark:bg-success/20',
  draft: 'border-border text-muted-foreground',
};

export function PolicyStatusBadge({
  status,
  className,
}: {
  status: PolicyStatus;
  className?: string;
}) {
  const { t } = useTranslation('policies');
  return (
    <Badge variant="outline" className={cn(TONE[status], className)}>
      {t(`status.${status}`)}
    </Badge>
  );
}
